import { createSelector } from '@ngrx/store';
import { locationsState } from '@shared/state/locations/selectors/root';

export const getHiddenLocations = createSelector(locationsState, (locState) => locState?.HiddenLocations?.listOfHiddenLocations);
